<template>
    <div class="review-wrapper relative text-white pb-24">
        <div class="review-content">
            <slick :options="slickOptions">
                <ReviewItems :review="review" v-for="(review, i) in reviewDatas.reviewLists" :key="i" />
            </slick>
        </div>
    </div>
</template>

<script>
    import Slick from 'vue-slick'
    // Slick Slider
    import 'slick-carousel/slick/slick.css'
    import ReviewItems from "./ReviewItems";

    let reviewDatas = {
        reviewLists: [
            {
                name: "Mr. Evans Cronin",
                img: require("@/assets/images/review-1.png"),
                content: 'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will…',
                rating: 5
            },
            {
                name: "Mary Crist",
                img: require("@/assets/images/review-2.png"),
                content: 'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will…',
                rating: 5
            },
            {
                name: "Lynner Stracke",
                img: require("@/assets/images/review-3.png"),
                content: 'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will…',
                rating: 5
            },
            {
                name: "Ines Bogisich",
                img: require("@/assets/images/review-4.png"),
                content: 'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will…',
                rating: 5
            },
        ]
    }

    export default {
        name: "ReviewBox",
        components: {
            ReviewItems,
            Slick
        },
        data() {
            return {
                reviewDatas
            }
        },
        computed: {
            slickOptions() {
                return {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: false,
                    draggable: false,
                    adaptiveHeight: true,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 4,
                                draggable: true
                            }
                        },
                        {
                            breakpoint: 1008,
                            settings: {
                                slidesToShow: 2,
                                variableWidth: true,
                                infinite: false,
                                draggable: true
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                infinite: false,
                                draggable: true,
                                variableWidth: true,
                                centerMod: true
                            }
                        },
                        {
                            breakpoint: 425,
                            settings: {
                                slidesToShow: 1,
                                infinite: false,
                                draggable: true,
                                centerPadding: '30px',
                                variableWidth: true,
                                centerMod: true
                            }
                        }
                    ]
                }
            },
        }
    }
</script>

<style scoped>

</style>